import Modal from '../../components/common/Modal';
import Avatar from '../../components/common/Avatar';
import { avatarFor } from '../../utils/avatar';

/* Quick lookup for an API-backed school member (from getGroupMember). */
export default function MemberInfoModal({ member, onClose }) {
  const av = member ? avatarFor(member.name, []) : null;
  return (
    <Modal open={!!member} onClose={onClose} title="Room Parent" maxWidth={380}>
      {member && (
        <>
          <div className="prof-head" style={{ marginBottom: 0 }}>
            <Avatar src={member.picture} initials={av.initials} color={av.color} size={56} fontSize={19} />
            <div className="info">
              <div className="nm">{member.name}</div>
              <div className="loc">{member.group || '—'}</div>
            </div>
          </div>
          <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <div className="ev-row-mini" style={{ cursor: 'default', padding: 0 }}>
              <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'var(--green-light)', display: 'grid', placeItems: 'center', flexShrink: 0 }}>📞</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 11, color: 'var(--muted)' }}>Phone</div>
                <div className="ev-title">{member.phone || '—'}</div>
              </div>
            </div>
            <div className="ev-row-mini" style={{ cursor: 'default', padding: 0 }}>
              <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'var(--green-light)', display: 'grid', placeItems: 'center', flexShrink: 0 }}>✉️</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 11, color: 'var(--muted)' }}>Email</div>
                <div className="ev-title">{member.email || '—'}</div>
              </div>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
}
